import {
  number,
  optional,
  string,
  boolean,
  type InferOutput,
  object
} from 'valibot'

import {
  createSorterSchema,
  ADDITIONAL_PAYMENT_CATEGORIES_SORT_KEYS
} from '@/features/shared/models'

export const AdditionalPaymentCategoriesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(ADDITIONAL_PAYMENT_CATEGORIES_SORT_KEYS),
  name: optional(string()), // 項目名
  isActive: optional(boolean()) // 有効/無効フラグ
})

export type AdditionalPaymentCategoriesSearch = InferOutput<
  typeof AdditionalPaymentCategoriesSearchSchema
>
